import React from 'react';
import { Alert, Badge } from 'react-bootstrap';

const labels = { GREEN: 'Alta', YELLOW: 'M\u00e9dia', RED: 'Baixa', UNKNOWN: 'N\u00e3o informada' };
const variants = { GREEN: 'success', YELLOW: 'warning', RED: 'danger', UNKNOWN: 'secondary' };
const format = value => value === null || value === undefined ? 'N\u00e3o informado' : Number(value).toLocaleString('pt-BR');

export default function WhatsAppConnectionInsights({ data }) {
  if (!data) return null;
  const remaining = data.is_unlimited ? 'Ilimitada' : data.estimated_remaining === null
    ? 'N\u00e3o calcul\u00e1vel' : format(data.estimated_remaining);
  return <div className={'border rounded p-3'}>
    <strong>Capacidade do n&uacute;mero na Meta</strong>
    <Badge bg={variants[data.quality_rating] || 'secondary'}>Qualidade: {labels[data.quality_rating] || data.quality_rating || labels.UNKNOWN}</Badge>
    <Metrics data={data} remaining={remaining} />
    <Restrictions items={data.restrictions || []} />
  </div>;
}

function Metrics({ data, remaining }) {
  const limit = data.is_unlimited ? 'Ilimitado' : format(data.messaging_limit);
  const status = data.meta_status || (data.available ? 'Dispon\u00edvel' : 'Consulta indispon\u00edvel');
  return <div className={'row g-3 mt-1'}>
    <Metric label={'Limite informado'} value={limit} />
    <Metric label={'Contatados pelo sistema'} value={format(data.contacted_unique_24h || 0)} />
    <Metric label={'Disponibilidade estimada'} value={remaining} />
    <Metric label={'Status Meta'} value={status} />
  </div>;
}

function Restrictions({ items }) {
  return items.length > 0
    ? <Alert variant={'warning'} className={'mt-3 mb-0 py-2'}><strong>Aten&ccedil;&atilde;o:</strong> {items.join(' ')}</Alert>
    : <div className={'small text-success mt-3'}>Nenhuma restri&ccedil;&atilde;o identificada nos dados consultados.</div>;
}

function Metric({ label, value }) {
  return <div className={'col-6 col-lg-3'}><div className={'text-muted small'}>{label}</div><strong>{value}</strong></div>;
}
